var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Urban Primary Health Centers (UPSC's)")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("Launched under the National Urban Health Mission (NUHM), this project provides healthcare and medical services to the urban slum population. We have been running it since August 2010 in the Roorkee Area.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": require(("./Uphc-pics/" + (file.name)))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": require(("./Uphc-pics/" + (file.name))),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca9b550","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Uphc/Uphc.vue
// module id = qBuk
// module chunks = 0